// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoPicker_container__3caSF","modal":"VideoPicker_modal__XXy3q"};